import React, { Component } from 'react';
// import Select from 'react-select'; // https://react-select.com/home#getting-started
import './CreateNewGroup.scss';
import { confirmAlert } from 'react-confirm-alert';
import ButtonPrimary from 'components/elements/button/button-primary/ButtonPrimary';
import ButtonSecondary from 'components/elements/button/button-secondary/ButtonSecondary';
// import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import { withRouter } from 'react-router-dom';
import ErrorMessage from 'components/elements/error-message/ErrorMessage';
import Localization, { setLanguage } from 'languages/components/admin/AdminLan';

import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';

class CreateNewGroup extends Component {
  constructor(props) {
    super(props);

    setLanguage();
    this.refForm = React.createRef();
    this.refSelectMunicipality = React.createRef();
    this.refGroupName = React.createRef();

    this.sendForm = this.sendForm.bind(this);
    this.clickGoBack = this.clickGoBack.bind(this);

    this.state = {
      dropdownOptions: props.municipalityList || [],
      selectedMunicipalities: [],
      alertUserError: false,
      errorMessage: {
        header: '',
        text: '',
      },
    };
  }

  componentDidMount() {
    const edit = this.props.customGroup;
    if (edit) {
      this.setState({
        selectedMunicipalities: edit.municipalities || [],
      });
    }
  }


  componentDidUpdate(prevProps) {
    if (prevProps.municipalityList !== this.props.municipalityList && this.props.municipalityList) {
      // Had to do this to update the dropdown options on first render
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ dropdownOptions: this.props.municipalityList });
    }
  }

  sendForm(f) {
    f.preventDefault();

    if (this.refForm.current.checkValidity()) {
      let obj = {};
      try {
        obj = {
          municipalities: this.state.selectedMunicipalities,
          name: this.refGroupName.current.value,
        };
        if (this.props.customGroup?.groupId) {
          obj.groupId = this.props.customGroup.groupId;
        }
      } catch (e) {
        this.setState({
          alertUserError: true,
          errorMessage: {
            header: Localization.errorFormHeader,
            text: Localization.errorFormText,
          },
        });
        return;
      }
      this.props.sendForm(obj);
    } else {
      this.setState({
        alertUserError: true,
        errorMessage: {
          header: Localization.errorFormHeader,
          text: Localization.errorFormText,
        },
      });
    }
  }


  clickGoBack() {
    confirmAlert({
      title: Localization.confirmTitle,
      message: Localization.confirmMessage,
      buttons: [
        {
          label: Localization.confirmYes,
          onClick: this.props.goBack,
        },
        {
          label: Localization.confirmNo,
          onClick: () => { },
        },
      ],
    });
  }

  render() {
    const isEditMode = !!this.props.customGroup;
    return (
      <div className="c_create-new-warning">
        <h1>{isEditMode ? 'Rediger gruppe' : 'Opprett gruppe'}</h1>
        {/*         debug
        <div>
          {this.props.userIsAdmin ? (
            <p>Bruker er admin</p>
          ) : (
            <p>Bruker er ikke admin</p>
          )}
        </div>
        <div>
          <h2>Props:</h2>
          <ul>
            {Object.keys(this.props).map(key => (
              <li key={key}>
                <strong>
                  {key}
                  :
                </strong>
                {' '}
                {JSON.stringify(this.props[key])}
              </li>
            ))}
          </ul>
        </div> */}

        {this.state.alertUserError && (
          <ErrorMessage
            header={this.state.errorMessage.header}
            text={this.state.errorMessage.text}
          />
        )}

        <form
          className="form form--create-new-warning"
          onSubmit={f => this.sendForm(f)}
          method="post"
          ref={this.refForm}
        >

          {/* <div className="input input--select input--square"> */}
          <div className="input input--square">
            <label htmlFor="text-name">Navn på gruppe</label>
            <input
              name="text-name"
              ref={this.refGroupName}
              type="text"
              defaultValue={isEditMode ? this.props.customGroup.name : ''}
            />
          </div>
          <div>
            <label htmlFor="text-name">Velg kommuner</label>
            {/* <label htmlFor="select-municipality">Velg kommuner</label> */}
            <DualListBox
              canFilter
              filterPlaceholder="Søk kommune..."
              options={this.state.dropdownOptions}
              selected={this.state.selectedMunicipalities}
              onChange={selected => this.setState({ selectedMunicipalities: selected })}
              showAllSelectButtons
              icons={{
                moveLeft: <span style={{ fontSize: '14px' }}>Fjern</span>,
                moveRight: <span style={{ fontSize: '14px' }}>Legg til</span>,
                moveAllLeft: <span style={{ fontSize: '14px' }}>Fjern alle</span>,
                moveAllRight: <span style={{ fontSize: '14px' }}>Legg til alle</span>,
              }}
              className="custom-dual-listbox"
            />
          </div>

          <div className="form--create-new-warning__buttons">
            <ButtonSecondary onClick={() => this.clickGoBack()}>
              {Localization.formBack}
            </ButtonSecondary>
            <ButtonPrimary onClick={f => this.sendForm(f)}>
              {isEditMode ? 'Lagre' : 'Opprett'}
            </ButtonPrimary>
          </div>

        </form>
      </div>
    );
  }
}

export default withRouter(CreateNewGroup);
